import { h, Component } from "preact";
import PropTypes from "prop-types";
import { connect } from "preact-redux";
import { getAllUsers, setManagerRoleForUser } from "../actions";
import { Loader, Card, Header } from "semantic-ui-react";
import styles from "./ManagersPage.scss";
import { UserCard } from "../components";
import { HappinessMenu, menuOptions } from "../../menu";
import { LOCALSTORAGE_USER_ID, ON_MOBILE_DEVICE } from "../../../config";
import { isManager } from "../../../support/auth";

export class ManagersPage extends Component {
  constructor(props) {
    super(props);
    isManager();

    this.setManagerRole = this.setManagerRole.bind(this);
    this.props.getAllUsers();
  }

  setManagerRole(user, isManager) {
    this.props.setManagerRoleForUser(user, isManager);
  }

  prepareUserCards(allUsers) {
    let userCards = [];
    allUsers.forEach(user => {
      userCards.push(
        <UserCard
          user={user}
          isCurrentUser={user.id === localStorage.getItem(LOCALSTORAGE_USER_ID)}
          settingIsManager={!this.props.setManagerRoleFor.indexOf(user.id)}
          setManagerRole={this.setManagerRole.bind(this)}
          key={user.id}
        />
      );
    });

    return userCards;
  }

  render() {
    const { allUsers } = this.props;
    const menu = (
      <HappinessMenu
        headerText={"All employees"}
        selectedPage={menuOptions.MANAGER_PAGE}
      />
    );
    const components = [
      <div key="infoHeader" className={styles.header}>
        <Header as="h1">
          Managers
          <Header.Subheader>
            Give or revoke managers privilages to users
          </Header.Subheader>
        </Header>
      </div>,
      <div key="allUsers" className={styles.item}>
        {allUsers ? (
          <Card.Group className={styles.cardGroup}>
            {this.prepareUserCards(allUsers)}
          </Card.Group>
        ) : (
          <Loader active indeterminate>
            Loading users
          </Loader>
        )}
      </div>,
    ];
    ON_MOBILE_DEVICE() ? components.push(menu) : components.unshift(menu);
    return <div className={styles.container}>{components}</div>;
  }
}

ManagersPage.PropTypes = {
  allUsers: PropTypes.array.isRequired,
  getAllUsers: PropTypes.func.isRequired,
  setManagerRoleFor: PropTypes.array.isRequired,
  setManagerRoleLoading: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
  allUsers: state.manager.allUsers,
  setManagerRoleLoading: state.manager.setManagerRoleLoading,
  setManagerRoleFor: state.manager.setManagerRoleFor,
});

const mapDispatchToProps = {
  getAllUsers,
  setManagerRoleForUser,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ManagersPage);



// WEBPACK FOOTER //
// ./src/modules/manager/pages/ManagersPage.js